/**
 * UI Store
 * Manages UI state like drawers, menus, and modals
 */
import { create } from 'zustand';

interface UIState {
  // Favorites drawer
  favoritesDrawerOpen: boolean;
  openFavoritesDrawer: () => void;
  closeFavoritesDrawer: () => void;
  toggleFavoritesDrawer: () => void;

  // Mobile menu (for future use)
  mobileMenuOpen: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;

  // Close all
  closeAll: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  // Favorites drawer
  favoritesDrawerOpen: false,
  openFavoritesDrawer: () => set({ favoritesDrawerOpen: true }),
  closeFavoritesDrawer: () => set({ favoritesDrawerOpen: false }),
  toggleFavoritesDrawer: () => set((s) => ({ favoritesDrawerOpen: !s.favoritesDrawerOpen })),

  // Mobile menu
  mobileMenuOpen: false,
  openMobileMenu: () => set({ mobileMenuOpen: true }),
  closeMobileMenu: () => set({ mobileMenuOpen: false }),

  // Close all
  closeAll: () =>
    set({
      favoritesDrawerOpen: false,
      mobileMenuOpen: false,
    }),
}));
